(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["content-sidebar"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    const sidebarBtn = document.querySelector('.meditions-bh-sidebar-btn');
    const sidebarLinks = document.querySelector('.meditions-bh-sidebar-links');
    if (sidebarBtn && sidebarLinks) {
      sidebarBtn.addEventListener('click', function () {
        sidebarLinks.classList.toggle('open');
        sidebarLinks.classList.toggle('closed');
      });
    }

    const sidebar = document.querySelector(".meditions-bh-sidebar");
    const offset = 100;
    window.addEventListener("scroll", function () {
        if (window.scrollY > offset) {
            sidebar.classList.add("scrolled");
        } else {
            sidebar.classList.remove("scrolled");
        }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["duromine-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    const sidebarBtn = document.querySelector('.meditions-bh-sidebar-btn');
    const sidebarLinks = document.querySelector('.meditions-bh-sidebar-links');
    if (sidebarBtn && sidebarLinks) {
      sidebarBtn.addEventListener('click', function () {
        sidebarLinks.classList.toggle('open');
        sidebarLinks.classList.toggle('closed');
      });
    }

    const sidebar = document.querySelector(".meditions-bh-sidebar");
    const offset = 100;
    window.addEventListener("scroll", function () {
        if (window.scrollY > offset) {
            sidebar.classList.add("scrolled");
        } else {
            sidebar.classList.remove("scrolled");
        }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
